export enum EDeviceTypes {
	Clock,
	Employee,
	Unkown
}
